var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNavFm = function SvgNavFm(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u76F4\u64AD copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u76F4\\u64AD-\\u672A\\u8BA4\\u8BC1\\u7528\\u6237",
    transform: "translate(-23.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy",
    transform: "translate(0.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u76F4\\u64AD",
    transform: "translate(23.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 8,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,11.0003662 C3.7855533,10.0881599 3,8.63581783 3,7 C3,5.36418217 3.7855533,3.91184014 5,2.99963381 M5,11.0003662 L5,11.0003662 M11,2.99963381 C12.2144467,3.91184014 13,5.36418217 13,7 C13,8.63581783 12.2144467,10.0881599 11,11.0003662 M11,2.99963381 L11,2.99963381 L11,2.99963381",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,13.9297424 C1.60879452,12.5465048 0,9.96112942 0,7 C0,4.03887058 1.60879452,1.45349524 4,0.0702575622 M4,13.9297424 L4,13.9297424 M12,0.0702575622 C14.3912055,1.45349524 16,4.03887058 16,7 C16,9.96112942 14.3912055,12.5465048 12,13.9297424 M12,0.0702575622 L12,0.0702575622 L12,0.0702575622",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNavFm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-fm.bae3033100f912630a4046d7e1f348b2.svg";